import * as types from './types';

const initialState = {
  // Workspace
  sugeridos: [],
  savedQueries: [],
  budgetUsedPct: 0,
  budgetUsed: null,
  budgetTotal: null,
  isLoadingWorkspace: false,

  // Conversación activa
  conversationId: null,
  queryId: null,
  queryResult: null,   // { columns, rows, summary, filtros, columnasDis, pagination }
  isLoadingResult: false,

  // Chat
  messages: [],
  isSending: false,

  // Input
  input: '',
  activeTab: 'queries'
};

const smartQueriesReducer = (state = initialState, action) => {
  switch (action.type) {

    case types.SQ_SET_TAB:
      return { ...state, activeTab: action.payload };

    case types.SQ_SET_INPUT:
      return { ...state, input: action.payload };

    // — Workspace —
    case types.SQ_LOAD_WORKSPACE_REQUEST:
      return { ...state, isLoadingWorkspace: true };

    case types.SQ_LOAD_WORKSPACE_SUCCESS:
      return {
        ...state,
        isLoadingWorkspace: false,
        sugeridos: action.payload.sugeridos || [],
        savedQueries: action.payload.guardados || [],
        budgetUsedPct: action.payload.budgetUsedPct || 0,
        budgetUsed:    action.payload.budgetUsed  !== undefined ? action.payload.budgetUsed  : state.budgetUsed,
        budgetTotal:   action.payload.budgetTotal !== undefined ? action.payload.budgetTotal : state.budgetTotal
      };

    case types.SQ_LOAD_WORKSPACE_ERROR:
      return { ...state, isLoadingWorkspace: false };

    // — Chat —
    case types.SQ_SEND_MESSAGE_REQUEST:
      return {
        ...state,
        isSending: true,
        messages: [...state.messages, { id: Date.now(), role: 'user', text: action.payload }],
        input: ''
      };

    case types.SQ_SEND_MESSAGE_SUCCESS:
      return {
        ...state,
        isSending: false,
        conversationId: action.payload.conversationId,
        queryId: action.payload.queryId,
        budgetUsedPct: action.payload.budgetUsedPct,
        budgetUsed:    action.payload.budgetUsed  !== undefined ? action.payload.budgetUsed  : state.budgetUsed,
        budgetTotal:   action.payload.budgetTotal !== undefined ? action.payload.budgetTotal : state.budgetTotal,
        queryResult: action.payload.queryResult || state.queryResult,
        messages: [...state.messages, {
          id: Date.now(),
          role: action.payload.type === 'clarification' ? 'clarification' : 'assistant',
          text: action.payload.answerText,
          opciones: action.payload.opciones || null,
          queryId: action.payload.queryId,
          filtros: action.payload.filtros || [],
          columnasDis: action.payload.columnasDis || []
        }]
      };

    case types.SQ_SEND_MESSAGE_ERROR:
      return {
        ...state,
        isSending: false,
        messages: [
          ...state.messages,
          { id: Date.now(), role: 'error', text: 'Ocurrió un error al procesar tu consulta. Por favor intenta de nuevo.' }
        ]
      };

    // — Saved queries —
    case types.SQ_SAVE_QUERY_SUCCESS:
      return { ...state, savedQueries: [action.payload, ...state.savedQueries] };

    case types.SQ_DELETE_SAVED_QUERY_REQUEST:
      return { ...state, savedQueries: state.savedQueries.filter(q => q.uuid !== action.payload) };

    // — Ejecutar guardada —
    case types.SQ_EXECUTE_QUERY_REQUEST:
      return { ...state, isLoadingResult: true };

    case types.SQ_EXECUTE_QUERY_SUCCESS:
      return {
        ...state,
        isLoadingResult: false,
        // Refine devuelve conversation_id: null — conservamos el existente
        conversationId: action.payload.conversationId || state.conversationId,
        queryId: action.payload.queryId || state.queryId,
        budgetUsedPct: action.payload.budgetUsedPct || state.budgetUsedPct,
        queryResult: action.payload.queryResult
      };

    case types.SQ_EXECUTE_QUERY_ERROR:
      return { ...state, isLoadingResult: false };

    // — Clear —
    case types.SQ_CLEAR_CONVERSATION:
      return {
        ...state,
        messages: [],
        input: '',
        conversationId: null,
        queryId: null,
        queryResult: null
      };

    default:
      return state;
  }
};

export default smartQueriesReducer;



// WEBPACK FOOTER //
// ./src/containers/smart-queries/store/reducer.js